





























































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import AddStratificationDialog from '@/components/dialog/AddStratificationDialog.vue';
import { useFieldsView } from '@/store/modules/fieldsView';
import FieldsViewExportCsv from './FieldsViewExportCsv.vue';
import FieldsViewGroupFilter from './FieldsViewGroupFilter.vue';
import FieldsViewRecentActivityFilter from './FieldsViewRecentActivityFilter.vue';
import FieldsViewSearchInput from './FieldsViewSearchInput.vue';
import FieldsViewSortBy from './FieldsViewSortBy.vue';
import FieldsViewStatusFilter from './FieldsViewStatusFilter.vue';

export default defineComponent({
	components: {
		FieldsViewSearchInput,
		FieldsViewGroupFilter,
		FieldsViewRecentActivityFilter,
		FieldsViewStatusFilter,
		FieldsViewSortBy,
		FieldsViewExportCsv,
		AddStratificationDialog,
	},
	setup(_, { root }) {
		const showDialog = ref(false);
		const showExportCSV = ref(false);
		const fieldRowsLength = computed(() => root.$store.getters['fieldsView/getFieldRowsLength']);
		const { resetOpenedGroupIds } = useFieldsView(root.$store);

		watch(showDialog, () => {
			if (showDialog.value) {
				resetOpenedGroupIds();
			}
		});

		return {
			showDialog,
			showExportCSV,
			fieldRowsLength,
			clearAllFilters: () => {
				root.$store.dispatch('fieldsView/clearAllFilters');
			},
		};
	},
});
